interface EquipmentCardProps {
  image: string;
  name: string;
}

export default function EquipmentCard({ image, name }: EquipmentCardProps) {
  return (
    <div className="group text-center cursor-default">
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[4/3] mb-3 ring-1 ring-background-200/50 group-hover:ring-primary-200/40 transition-all duration-500">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/15 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
      </div>
      <p className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-300">{name}</p>
    </div>
  );
}